import React from 'react';
import classNames from 'classnames';
import { styled } from 'styled-components';
import { ComponentSize } from './types';

export const Spinner = ({ className, type = 'spinner', size = ComponentSize.SM }: SpinnerProps): React.JSX.Element => {
    const spinnerClasses = classNames(
        'loading',
        type === 'ball' ? 'loading-ball' : '',
        type === 'bars' ? 'loading-bars' : '',
        type === 'dots' ? 'loading-dots' : '',
        type === 'infinity' ? 'loading-infinity' : '',
        type === 'ring' ? 'loading-ring' : '',
        type === 'spinner' ? 'loading-spinner' : '',
        size === ComponentSize.LG ? 'loading-lg' : '',
        size === ComponentSize.MD ? 'loading-md' : '',
        size === ComponentSize.SM ? 'loading-sm' : '',
        size === ComponentSize.XS ? 'loading-xs' : ''
    );

    return (
        <SpinnerContainer className={className}>
            <span className={spinnerClasses}></span>
        </SpinnerContainer>
    );
};

interface SpinnerProps {
    className?: string;
    type?: 'spinner' | 'dots' | 'ring' | 'ball' | 'bars' | 'infinity';
    size?: 'xs' | 'sm' | 'md' | 'lg';
}

const SpinnerContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export default Spinner;
